import { FileType } from "common/components/Folders";
import { checkDate } from "common/helpers/Date";
import { Nullable } from "common/types";
import { Map, Record } from "immutable";
import { DateStringNumber } from "common/records";

export const fromJSON = (json: Partial<IFolderData>): FolderRecord => {
  const recordData: IFolderRecord = { ...(json as any) };

  if (json.createParams) {
    recordData.createParams = new FolderCreateRecord(json.createParams);
  }

  if (json.created_at) {
    recordData.created_at = checkDate(json.created_at);
  }

  if (json.updated_at) {
    recordData.updated_at = checkDate(json.updated_at);
  }

  return new FolderRecord(recordData);
};

export interface IFolderCreateRecord {
  folderable_id: number;
  folderable_type: string;
  parent_name: string;
}

const defaultFolderCreateRecord: IFolderCreateRecord = {
  folderable_id: 0,
  folderable_type: "",
  parent_name: "",
};

export type RootFolderNames = "Presentations" | "Documents";
export const RootFolderNamesMap = Map<FileType, RootFolderNames>({
  presentations: "Presentations",
  documents: "Documents",
});

export class FolderCreateRecord extends Record(defaultFolderCreateRecord) implements IFolderCreateRecord {}

export interface IFolderData {
  id: number;
  name: string;
  sort_order: number;
  folderable_id: number;
  folderable_type: string;
  parent_id: number;
  loading?: boolean;
  archived?: boolean;
  createParams?: IFolderCreateRecord;

  created_at: DateStringNumber;
  updated_at: DateStringNumber;
}

export interface IFolderRecord {
  id: number;
  name: string;
  sort_order: Nullable<number>;
  folderable_id: number;
  folderable_type: string;
  parent_id: number;
  loading: boolean;
  archived: boolean;
  createParams: FolderCreateRecord;

  created_at: Date;
  updated_at: Date;
}

const defaultFolderProps: IFolderRecord = {
  id: 0,
  name: "",
  sort_order: null,
  folderable_id: 0,
  folderable_type: "",
  parent_id: 0,
  loading: true,
  archived: false,
  createParams: new FolderCreateRecord({}),

  created_at: new Date(),
  updated_at: new Date(),
};

export class FolderRecord extends Record(defaultFolderProps) implements IFolderRecord {}
